// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__DfQ9q","contentBox":"styles_contentBox__ZFeLa","buttonsBox":"styles_buttonsBox__qbcEX","logoBox":"styles_logoBox__3aGVw"};